import axios from "axios"
import { TallyConfig } from "../helpers/constants"
import { xmlToJs } from "../helpers/xmltojs"
import { xmlFormatter } from "../helpers/xmlFormatter"

export async function GetLastAlterId() {

    let data = `
        <ENVELOPE>
            <HEADER>
                <VERSION>1</VERSION>
                <TALLYREQUEST>Export</TALLYREQUEST>
                <TYPE>Collection</TYPE>
                <ID>Collection of Ledgers</ID>
            </HEADER>
            <BODY>
                <DESC>
                    <STATICVARIABLES>
                        <SVCURRENTCOMPANY>${TallyConfig.company}</SVCURRENTCOMPANY>
                        <SVEXPORTFORMAT>$$SysName:XML</SVEXPORTFORMAT>
                    </STATICVARIABLES>
                    <TDL>
                    <TDLMESSAGE>
                        <COLLECTION NAME="Collection of Ledgers" ISMODIFY="No">
                            <TYPE>Company</TYPE>
                            <FETCH>GUID,ALTERID,MASTERID,ALTVCHID,ALTMSTID</FETCH>
                            <FILTERS>GroupFilter</FILTERS>
                        </COLLECTION>
                        <SYSTEM TYPE="FORMULAE" NAME="GroupFilter">$isaggregate =  "No" </SYSTEM>
                    </TDLMESSAGE>
                    </TDL>
                </DESC>
            </BODY>
        </ENVELOPE>

    `

    data = xmlFormatter(data)
    try {
        let resp = await window.electron.tallyConnect({
            url: `${TallyConfig.host}:${TallyConfig.port}`,
            method: 'POST',
            headers: {
                'Content-Type': 'application/xml',
            },
            timeout: 500000,
            data: data
        })
        if (resp.status === 200) {
            let jsonData = resp?.data

            let company = jsonData.ENVELOPE?.BODY?.DATA?.COLLECTION?.COMPANY || []

            if(!(company instanceof Array)){
                company = [company]
            }

            let alterId = company[0]?.ALTMSTID?._text || -1
            alterId = parseInt(alterId)
            let voucherId = company[0]?.ALTVCHID?._text || -1
            voucherId = parseInt(voucherId)

            return {
                alterId,
                voucherId
            }
        } else {
            return false
        }
    } catch (err) {
        return false
    }
}